import { useRef, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useOutsideClick } from '@scramble/hooks';
import { EMPTY_DASH, prettyMoney } from '@scramble/utils';
import { useConfirmedAllocationStatus } from '@/hooks/shared/useConfirmedAllocationStatus';
import { useCalculateEarnings } from '@/pages/InvestingPage/hooks/useCalculateEarnings';
import { EarningsAndRepayments } from './schedules';
import IconArrow from '@scramble/design-system/icons/chevron-down.svg';
import s from './index.module.scss';

export const InvestmentBreakdown = () => {
  const ref = useRef();
  const { t } = useTranslation();
  const { totalAllocated } = useConfirmedAllocationStatus();
  const { plannedEarning, apr } = useCalculateEarnings();
  const [open, setOpen] = useState(false);
  useOutsideClick(ref,() => setOpen(false), open);

  if (!totalAllocated) return null;

  return (
    <div className={s.wrapper} ref={ref}>
      <div
        className={classnames(s.header, open && 'open')}
        onClick={() => setOpen(!open)}
      >
        <div className="f-headline-xs f-500">
          {t('investing:inv_breakdown.investment_breakdown')}
        </div>
        <div className={classnames(s.header_arrow, open && 'open')}>
          <img src={IconArrow} width={20} height={20} alt="arrow" />
        </div>
      </div>
      {open && (
        <div className={s.dropdown}>
          <div className={s.dropdown_content}>
            <div className={s.planned}>
              <div className={s.planned_row}>
                <div className="f-body-md">
                  {t('investing:inv_breakdown.planned_apr')}
                </div>
                <div className="f-body-md f-500">
                  {apr ? `${apr}%` : EMPTY_DASH}
                </div>
              </div>
              <div className={s.planned_row}>
                <div className="f-body-md">
                  {t('investing:inv_breakdown.planned_earnings')}
                </div>
                <div className="f-body-md f-500">
                  {plannedEarning
                    ? t('investing:inv_breakdown.up_to', {
                        amount: prettyMoney(plannedEarning),
                      })
                    : EMPTY_DASH}
                </div>
              </div>
            </div>
            <EarningsAndRepayments />
          </div>
        </div>
      )}
    </div>
  );
};
